import { SectionCard } from "./SectionCard";
import { FooterText } from "./FooterText";

const InsuranceTermsAndConditions = () => {
  return (
    <div className="container my-4 px-3" style={{ textAlign: "justify" }}>
      <header className="pb-3 mb-4 text-center">
        <h2 className="card-title text-primary fw-bolder">
          TERMS AND CONDITIONS – KEGOW INSURANCE FEATURE
        </h2>
        <p className="text-muted mt-2">
          Please read the Terms and Conditions below carefully before using the
          Kegow Insurance feature. If you do not accept these Terms, do not
          proceed.
        </p>
      </header>
      <div>
        <SectionCard
          title="1. Introduction"
          customContent={
            <>
              <p>
                These Terms and Conditions (<strong>"Terms"</strong>) govern
                your access to and use of the Insurance Feature available within
                the Kegow Application (<strong>"App"</strong>).
              </p>
              <p className="mt-2">
                The Insurance Feature enables users to discover, purchase,
                manage, and make claims on insurance products offered by
                third-party insurance providers (<strong>"Insurers"</strong>).
              </p>
              <p className="mt-2">
                By using this feature, you agree to these Terms.
              </p>
            </>
          }
        />

        <SectionCard
          title="2. Nature of the Service"
          customContent={
            <>
              <ul className="ms-4 mb-2">
                <li>
                  Kegow provides a digital distribution platform for insurance
                  products.
                </li>
                <li>Kegow is not an insurance company or underwriter.</li>
                <li>
                  All insurance products are:
                  <ul style={{ listStyleType: "circle" }}>
                    <li>Created;</li>
                    <li>Underwritten;</li>
                    <li>Managed</li>
                  </ul>
                  by licensed third-party Insurers.
                </li>
              </ul>

              <p className="mb-2">Each insurance product is subject to:</p>
              <ul className="ms-4 mb-2">
                <li>These platform Terms; and</li>
                <li>The specific Insurer's policy terms.</li>
              </ul>

              <p>
                In the event of conflict, the Insurer's policy terms prevail for
                coverage matters.
              </p>
            </>
          }
        />

        <SectionCard
          title="3. Role of Kegow"
          customContent={
            <>
              <p className="fw-bold mb-2">Kegow acts as:</p>
              <ul className="ms-4 mb-3">
                <li>A marketplace and facilitator;</li>
                <li>A payment processor (via wallet infrastructure);</li>
                <li>
                  A technical integration layer between users and Insurers.
                </li>
              </ul>

              <p className="fw-bold mb-2">Kegow does not:</p>
              <ul className="ms-4">
                <li>Provide insurance coverage;</li>
                <li>Guarantee claims;</li>
                <li>Make underwriting decisions.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="4. Eligibility"
          customContent={
            <>
              <p>To use the Insurance feature, you must:</p>
              <ul className="ms-4 mb-3">
                <li>Be at least 18 years old;</li>
                <li>Have an active Kegow account;</li>
                <li>Meet eligibility criteria defined by each Insurer.</li>
              </ul>
              <p>
                Additional restrictions (e.g., age limits, geography) may apply
                per product as listed in the Insurer's policy terms.
              </p>
            </>
          }
        />

        <SectionCard
          title="5. Insurance Providers"
          customContent={
            <>
              <ul className="ms-4 mb-3">
                <li>The App may display multiple insurance providers.</li>
                <li>Each provider operates independently.</li>
                <li>
                  Users may select a provider and product of their choice.
                </li>
              </ul>

              <p className="fw-bold mb-2">Kegow may:</p>
              <ul className="ms-4">
                <li>Add or remove providers at any time;</li>
                <li>Modify available offerings without prior notice.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="6. Plan Selection & Product Information"
          customContent={
            <>
              <p className="mb-2">Each insurance product will display:</p>
              <ul className="ms-4 mb-3">
                <li>Plan name and pricing;</li>
                <li>Coverage benefits and limits;</li>
                <li>Waiting periods;</li>
                <li>Billing frequency;</li>
                <li>Key exclusions.</li>
              </ul>

              <p className="mb-2">Users are responsible for reviewing:</p>
              <ul className="ms-4">
                <li>All product details;</li>
                <li>The Insurer's full policy terms.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="7. KYC & Data Sharing"
          customContent={
            <>
              <p className="mb-2">To activate insurance services:</p>
              <ul className="ms-4 mb-2">
                <li>
                  Kegow may share your profile data with selected Insurers,
                  including:
                  <ul style={{ listStyleType: "circle" }}>
                    <li>Identity details;</li>
                    <li>Contact information;</li>
                    <li>Demographic data.</li>
                  </ul>
                </li>
              </ul>

              <p className="mb-2">By proceeding, you:</p>
              <ul className="ms-4">
                <li>Consent to this data sharing;</li>
                <li>Confirm accuracy of your information.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="8. Policy Purchase & Activation"
          customContent={
            <>
              <ul className="ms-4 mb-2">
                <li>Premiums are paid via your Kegow wallet.</li>
                <li>
                  A policy becomes active only after:
                  <ul style={{ listStyleType: "circle" }}>
                    <li>Successful payment;</li>
                    <li>Confirmation from the Insurer.</li>
                  </ul>
                </li>
              </ul>

              <p className="mb-2">Upon activation:</p>
              <ul className="ms-4">
                <li>A Policy ID or equivalent identifier is issued.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="9. Billing & Payment"
          customContent={
            <>
              <ul className="ms-4 mb-3">
                <li>
                  Users may select billing frequency as offered by the Insurer.
                </li>
                <li>Full payment is required upfront for each cycle.</li>
              </ul>

              <p className="fw-bold mb-2">If:</p>
              <ul className="ms-4">
                <li>Payment fails, no policy is created;</li>
                <li>
                  Wallet balance is insufficient, the transaction is declined.
                </li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="10. Auto-Renewal"
          customContent={
            <>
              <ul className="ms-4 mb-2">
                <li>Some products may offer auto-renewal.</li>
                <li>
                  If enabled:
                  <ul style={{ listStyleType: "circle" }}>
                    <li>
                      Your wallet/payment method will be automatically charged.
                    </li>
                  </ul>
                </li>
              </ul>

              <p className="mb-2">Failure to renew may result in:</p>
              <ul className="ms-4">
                <li>Policy lapse;</li>
                <li>Loss of coverage.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="11. Waiting Periods & Coverage Conditions"
          customContent={
            <ul className="ms-4">
              <li>
                Coverage may be subject to waiting periods defined by the
                Insurer.
              </li>
              <li>Certain benefits may not be immediately accessible.</li>
              <li>
                Users must review product-specific conditions before purchase.
              </li>
            </ul>
          }
        />

        <SectionCard
          title="12. Claims Process"
          customContent={
            <>
              <p className="mb-2">Users may submit claims via:</p>
              <ul className="ms-4 mb-3">
                <li>The App; or</li>
                <li>Directly through the Insurer.</li>
              </ul>

              <p className="mb-2">Claims require:</p>
              <ul className="ms-4 mb-3">
                <li>Supporting documentation;</li>
                <li>Accurate reporting.</li>
              </ul>

              <p className="fw-bold mb-2">Important:</p>
              <ul className="ms-4">
                <li>Claims are evaluated solely by the Insurer.</li>
                <li>Kegow does not influence claim outcomes.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="13. Claim Outcomes"
          customContent={
            <>
              <p>The Insurer is solely responsible for:</p>
              <ul className="ms-4">
                <li>Claim approval or rejection;</li>
                <li>Claim settlement timelines;</li>
                <li>Dispute resolution related to claims.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="14. Policy Management"
          customContent={
            <>
              <p className="mb-2">Users can:</p>
              <ul className="ms-4">
                <li>View active and past policies;</li>
                <li>
                  Access:
                  <ul style={{ listStyleType: "circle" }}>
                    <li>Coverage details;</li>
                    <li>Policy ID;</li>
                    <li>Payment history;</li>
                  </ul>
                </li>
                <li>Manage auto-renewal.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="15. Provider Support"
          customContent={
            <>
              <p className="mb-2">Each Insurer will provide:</p>
              <ul className="ms-4 mb-3">
                <li>Customer care channels;</li>
                <li>Claims support;</li>
                <li>Emergency assistance (where applicable).</li>
              </ul>
              <p>Kegow may display these support channels within the App.</p>
            </>
          }
        />

        <SectionCard
          title="16. Cancellation & Refunds"
          customContent={
            <>
              <ul className="ms-4">
                <li>Cancellation terms are defined by each Insurer.</li>
                <li>
                  Refunds (if applicable) are governed by:
                  <ul style={{ listStyleType: "circle" }}>
                    <li>Insurer policies;</li>
                    <li>Applicable laws.</li>
                  </ul>
                </li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="17. Limitation of Liability"
          customContent={
            <>
              <p>Kegow shall not be liable for:</p>
              <ul className="ms-4">
                <li>Claim rejections or delays;</li>
                <li>Medical or financial outcomes;</li>
                <li>Actions or omissions of Insurers;</li>
                <li>Errors resulting from inaccurate user information.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="18. Data Protection & Privacy"
          customContent={
            <>
              <p>By using the Insurance Feature:</p>
              <ul className="ms-4">
                <li>You consent to data sharing with Insurers;</li>
                <li>
                  Your data may be processed using secure cloud infrastructure;
                </li>
                <li>
                  Even where services are local, data may be stored or processed
                  outside Nigeria in compliance with applicable data protection
                  laws.
                </li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="19. Security"
          customContent={
            <ul className="ms-4">
              <li>All transactions are secured using encryption.</li>
              <li>
                Payment and policy operations are protected against unauthorized
                access.
              </li>
            </ul>
          }
        />

        <SectionCard
          title="20. Suspension of Access"
          customContent={
            <>
              <p>Kegow may restrict access if:</p>
              <ul className="ms-4">
                <li>Fraud or misuse is suspected;</li>
                <li>Required by regulators;</li>
                <li>System maintenance is ongoing.</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="21. Regulatory Compliance"
          customContent={
            <>
              <p>All insurance services are subject to:</p>
              <ul className="ms-4">
                <li>Applicable Nigerian laws;</li>
                <li>Relevant regulatory authorities (e.g., NAICOM).</li>
              </ul>
            </>
          }
        />

        <SectionCard
          title="22. Governing Law"
          customContent={
            <p>
              These Terms shall be governed by the laws of the Federal Republic
              of Nigeria.
            </p>
          }
        />

        <SectionCard
          title="23. Amendments"
          customContent={
            <p>
              Kegow may update these Terms at any time. Continued use indicates
              acceptance.
            </p>
          }
        />

        <SectionCard
          title="Acknowledgement"
          customContent={
            <p className="fw-bold mb-0">
              BY USING THE INSURANCE FEATURE, I HEREBY ACKNOWLEDGE THAT I HAVE
              READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS AND
              CONDITIONS AND THE APPLICABLE INSURER'S SPECIFIC POLICY TERMS. MY
              CONTINUED USE OF THE SERVICE CONSTITUTES MY ACCEPTANCE OF THESE
              TERMS.
            </p>
          }
        />

        <FooterText
          supportText="For inquiries or customer support regarding the Kegow Insurance feature, please contact Kegow customer service through the official app channels."
          lastUpdated="September 28, 2026."
          termsText="Kegow Insurance Feature Terms and Conditions."
        />
      </div>
    </div>
  );
};

export default InsuranceTermsAndConditions;
